<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Setar Ocorrência
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="modeloOcorrencia"
            :items="modelosOcorrenciaAtivo"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Modelo Ocorrencia"
            hide-details
            prepend-icon="label_important"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado"
            @change="changeModeloOcorrencia"
          ></v-autocomplete>
          <SharedTextarea
            :value="atividadeOcorrencia.Descricao"
            @change="v => atividadeOcorrencia.Descricao = v"
            textareaId="ocorrencia-add-item" 
            label="Ocorrência" 
            required
            outline
            :rules="[rules.required]"
          >
            <v-flex xs12 md6>
              <v-autocomplete 
                v-model="atividadeOcorrencia.TipoOcorrencia"
                :items="tiposOcorrenciaFiltro"
                item-text="Descricao"
                return-object
                menu-props="auto"
                label="Tipo Ocorrência"
                :hide-details="$vuetify.breakpoint.mdAndUp"
                prepend-icon="comment"
                @change="changeTipoOcorrencia"
                auto-select-first
                no-data-text="Registro não encontrado."
                class="mt-0"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md5>
              <v-text-field 
                v-model="duracao"
                mask="time" 
                return-masked-value 
                :hide-details="$vuetify.breakpoint.mdAndUp"
                prepend-icon="access_time" 
                @click:prepend="calculaDuracaoOcorrencia(atividadeOcorrencia.DataOcorrencia)"
                label="Duração" 
                placeholder="00:00"
                class="mt-0"
              ></v-text-field>
            </v-flex>
          </SharedTextarea>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import SharedTextarea from '@/components/shared/Textarea';

export default {
  props: ["value", "atividadeOcorrencia", "loading"],
  components: {
    SharedTextarea
  },
  data: () => ({
    duracao: '00:00',
    modeloOcorrencia: null
  }),
  methods: {
    ...mapMutations(["showNotification"]),
    ...mapActions(["fetchTiposOcorrencia", "fetchModelosOcorrencia"]),
    async inicializaBuscas() {
      await this.fetchModelosOcorrencia();
      await this.fetchTiposOcorrencia();
    },
    changeTipoOcorrencia(obj) {
      this.atividadeOcorrencia.TipoOcorrencia = obj.Descricao;
      this.atividadeOcorrencia.IdTipoOcorrencia = obj.IdTipoOcorrencia;
    },
    changeModeloOcorrencia(obj) {
      if (obj) {
        this.atividadeOcorrencia.TipoOcorrencia = obj.TipoOcorrencia;
        this.atividadeOcorrencia.IdTipoOcorrencia = obj.IdTipoOcorrencia;
        this.atividadeOcorrencia.Descricao = obj.Ocorrencia;
        this.duracao = this.duracaoItem(obj.Duracao);
      }
    },
    calculaDuracaoOcorrencia(dataOcorrencia) {
      let inicio = this.moment(new Date(1970, 0, 1, 0, 0, 0));
      // Calcula duração entre o início da ocorrencia e agora
      let dtOcorrencia = this.moment(dataOcorrencia);
      let fim = this.moment();
      let diferencaDuration = this.moment.duration(fim.diff(dtOcorrencia));
      // Cria data final somando a duração total com a data inicio
      let duracaoFinal = inicio.add(diferencaDuration).toDate();
      this.duracao = this.duracaoItem(duracaoFinal);
    },
    duracaoItem(data) {
      // Verifica se o ano da tempo é 1899 == ano padrão DELPHI
      // Caso não, estaremos usando o ano padrão JavaScript == 1970
      const anoDelphi = new Date(data).getFullYear() == 1899;
      let inicio = anoDelphi ? this.moment([1899, 11, 30]): new Date(1970, 0, 1, 0, 0, 0);
      // console.log('Inicio:', inicio.format('DD/MM/YYYY HH:mm'));
      let final = this.moment(data);
      // console.log('Final:', final.format('DD/MM/YYYY HH:mm'));
      // Pega a diferença entre as datas em millisegundos
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      if (duracaoFinal.length === 4) duracaoFinal = `0${duracaoFinal}`;
      return duracaoFinal;
    },
    calculaDuracao() {
      let inicio = this.moment(new Date(1970, 0, 1, 0, 0, 0));
      // Calcula duração entre o início da ocorrencia e agora
      let dtOcorrencia = this.moment(this.atividadeOcorrencia.DataOcorrencia);
      let fim = this.moment();
      let diferencaDuration = this.moment.duration(fim.diff(dtOcorrencia));
      // Cria data final somando a duração total com a data inicio
      let duracaoFinal = inicio.add(diferencaDuration).toDate();
      this.duracao = this.duracaoItem(duracaoFinal);
    },
    adiciona() {
      if (this.atividadeOcorrencia.Descricao) {
        // Adiciona o colaborador
        this.atividadeOcorrencia.IdColaborador = this.user.IdColaborador;
        this.atividadeOcorrencia.Colaborador = this.user.Colaborador;
        // Converte duração em data
        const minutoDuracao = `${this.duracao[3]}${this.duracao[4]}`;
        const horaDuracao = `${this.duracao[0]}${this.duracao[1]}`;
        this.atividadeOcorrencia.Duracao = this.moment(new Date(1970, 0, 1, 0, 0, 0)).add(horaDuracao, 'h').add(minutoDuracao, 'm').toDate();
        if (this.atividadeOcorrencia.IdAtividade) {
          this.$emit("setaOcorrencia", this.atividadeOcorrencia);
        } else {
          this.$emit("setaOcorrenciaSelected", this.atividadeOcorrencia);
        }
        this.duracao = '00:00';
      } else {
        this.showNotification({ text: "Informe a Ocorrência", status: 'error' });
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.$nextTick(() => document.getElementById('ocorrencia-add-item').focus());
        if (this.atividadeOcorrencia.IdOcorrencia) this.calculaDuracao();
        this.inicializaBuscas();
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'tiposOcorrencia', 'modelosOcorrenciaAtivo', 'rules']),
    tiposOcorrenciaFiltro() {
      return this.tiposOcorrencia.filter(tipo => [1, 3].includes(tipo.IdTipoOcorrencia));
    },
  },
};
</script>

<style>
</style>
